export default __webpack_public_path__ + "b6c2465281cb0792b5ba9df211a5b9f0.svg";